import React from "react";
import { MARKETS } from "../config/markets";
import "./MarketSwitch.css";

export default function MarketSwitch({ active, onChange }) {
  return (
    <div className="market-switch">
      {MARKETS.map((m) => (
        <button
          key={m.key}
          className={`market-tab ${active === m.key ? "active" : ""}`}
          onClick={() => onChange(m.key)}
        >
          <span className="market-dot" />
          {m.label}
        </button>
      ))}
    </div>
  );
}
